import { SideMenuDeviceAlarmAPI, SideMenuOperatorAlarmAPI } from '../api/side-menu-alarm.api';
import { SideMenuAlarm } from '../model/side-menu-alarm.model';

export const mapOperatorFilterAlarmFromAPIToModel = (alarm: SideMenuOperatorAlarmAPI): SideMenuAlarm => ({
    WARNING: alarm.alarms.find((a) => a.type === 'DUE_SOON')?.count ?? 0,
    ERROR: alarm.alarms.find((a) => a.type === 'MISSED_STAGE')?.count ?? 0,
    totalAlarm: alarm.totalOperators ?? 0,
});

export const mapOperatorFilterAlarmsFromAPIToModel = (
    alarms: SideMenuOperatorAlarmAPI[]
): Record<string, SideMenuAlarm> =>
    alarms.reduce(
        (prev, current) => {
            prev[current.identifier] = mapOperatorFilterAlarmFromAPIToModel(current);
            return prev;
        },
        {} as Record<string, SideMenuAlarm>
    );

export const mapDeviceFilterAlarmFromAPIToModel = (alarm: SideMenuDeviceAlarmAPI): SideMenuAlarm => ({
    WARNING: alarm.alarms.find((a) => a.type === 'WARNING')?.count ?? 0,
    ERROR: alarm.alarms.find((a) => a.type === 'ERROR')?.count ?? 0,
    totalAlarm: alarm.totalDevices ?? 0,
});

export const mapFilterAlarmsFromAPIToModel = (alarms: SideMenuDeviceAlarmAPI[]): Record<string, SideMenuAlarm> =>
    alarms.reduce(
        (prev, current) => {
            prev[current.identifier] = mapDeviceFilterAlarmFromAPIToModel(current);
            return prev;
        },
        {} as Record<string, SideMenuAlarm>
    );
